var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("基地管理")]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { name: "baseList" } } },
                [_vm._v("基地列表")]
              ),
              _c("el-breadcrumb-item", [_vm._v("生产数据维护")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.listParams, "label-width": "100px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "基地名称：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "请选择基地",
                              },
                              model: {
                                value: _vm.listParams.farmId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listParams, "farmId", $$v)
                                },
                                expression: "listParams.farmId",
                              },
                            },
                            _vm._l(_vm.baseNameList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.title, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.loadTableData },
                            },
                            [_vm._v(" 查询 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: {
                slot: "content",
                data: _vm.tableData,
                "max-height": "800",
                border: "",
              },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { prop: "farmId", align: "center", label: "id" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "farmTitle",
                  align: "center",
                  label: "基地名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "addressAccount",
                  align: "center",
                  label: "种植位置数量",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "measureTotal",
                  align: "center",
                  label: "总亩数",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "areaTitle",
                  align: "center",
                  label: "种植位置(个)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.areaTitleList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.areaTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "measure", align: "center", label: "亩数(亩)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.areaTitleList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.measure))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.areaTitleList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editItem(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _c(
                                "confirm-button",
                                {
                                  staticStyle: { margin: "0 10px" },
                                  attrs: {
                                    type: "text",
                                    title: "确认要删除该条数据？",
                                  },
                                  on: {
                                    confirmed: function ($event) {
                                      return _vm.deleteItem(item.areaId)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("删除")])]
                              ),
                            ],
                            1
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  staticStyle: { width: "80%" },
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "基地名称：", prop: "farmId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { size: "small", placeholder: "请选择基地" },
                          model: {
                            value: _vm.itemParams.farmId,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "farmId", $$v)
                            },
                            expression: "itemParams.farmId",
                          },
                        },
                        _vm._l(_vm.baseNameList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.title, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总亩数：", prop: "measureTotal" } },
                    [
                      _c("el-input-number", {
                        attrs: { size: "small", min: 1, label: "描述文字" },
                        model: {
                          value: _vm.itemParams.measureTotal,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "measureTotal", $$v)
                          },
                          expression: "itemParams.measureTotal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "种植位置：", prop: "areaTitleList" } },
                    _vm._l(
                      _vm.itemParams.areaTitleList,
                      function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { width: "100%", display: "flex" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "small",
                                placeholder: "请输入种植位置",
                              },
                              model: {
                                value: _vm.itemParams.areaTitleList[index],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.itemParams.areaTitleList,
                                    index,
                                    $$v
                                  )
                                },
                                expression: "itemParams.areaTitleList[index]",
                              },
                            }),
                            index !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "mgl10",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteAreaTitle(index)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.addAreaTitle },
                        },
                        [_vm._v("+增加")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveItem("dialogForm")
                            },
                          },
                        },
                        [_vm._v(" 保 存 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }